import { FC, memo } from 'react';

import { ImageData } from '../VariationOne';
import SharedUploadedImageRow from '../shared/UploadedImageRow';
import SettingsModal from './SettingsModal';

interface Props {
  image: ImageData;
  imageIndex: number;
  setImages: React.Dispatch<React.SetStateAction<ImageData[]>>;
  type: 'left' | 'right';
  hasText?: boolean;
}

const UploadedImageRow: FC<Props> = ({
  image,
  imageIndex,
  setImages,
  type,
  hasText,
}) => {
  const settingsApplied = false;

  return (
    <SharedUploadedImageRow
      image={image}
      imageIndex={imageIndex}
      setImages={setImages as any}
      showText={!!hasText}
      showSettings={true}
      showPreview={false}
      aspectRatio={600 / 630}
      imgRatioX={60}
      imgRatioY={63}
      textDebounceDelay={300}
      settingsApplied={settingsApplied}
      settingsModal={
        <SettingsModal
          type={type}
          imageIndex={imageIndex}
          setImages={setImages}
          image={image}
          onClose={() => {}}
        />
      }
    />
  );
};

export default memo(UploadedImageRow);
